module.exports = "https://www.gc-qa.gnp.com.mx/d7504ef929bd2cc1e1508bd39f871f37.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/facebook-2.png
// module id = 8107
// module chunks = 0